import { AuthenticationService } from './../../../@core/auth/authentication.service';
import { CredentialsService } from './../../../@core/auth/credentials.service';
import {
  CalculatorResponseDTO,
  DigitalIdDTO,
  DigitalIdResponseDTO,
  FinancingCallDTO,
  FinancingMangoShow,
} from './../../model/requests-model';
import { RequestDataMgService } from './request-data-mg-service.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { forkJoin } from 'rxjs';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import {
  FORM_MG,
  FINANCIAL_PRODUCT_MG,
  REQUEST_DATA_MG,
  REQUEST_DATA,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
  PENDIENTES_DE_DATOS,
  POINT_OF_SALE,
  REQUEST_MODE_NEW,
} from '@app/@core/constants/requests.constants';
import { ComercialProductResponseDTO, CommonDataDTO, TariffDTO } from '@app/requests/model/combos-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import * as _moment from 'moment';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

const moment = _moment;

@Component({
  selector: 'scf-request-data-mg',
  templateUrl: './request-data-mg.component.html',
  styleUrls: ['./request-data-mg.component.scss'],
})
export class RequestDataMgComponent implements OnInit, OnChanges {
  @Input() public mode: string = 'new';
  @Input() public request: any = null;
  @Input() establishment: string;
  @Input() state: CommonDataDTO;
  @Input() vendor: string;
  @Output() financeEmitter = new EventEmitter<CalculatorResponseDTO>();
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  public requestDataMgForm: FormGroup;

  expirationDaysList: CommonDataDTO[];
  commercialProductList: CommonDataDTO[];
  lineProductList: CommonDataDTO[];
  productList: CommonDataDTO[];
  formPaymentList: CommonDataDTO[];
  tariffsList: TariffDTO[] = [];

  //public financeMgList: FinancingMangoShow[] = [];

  selectedCommercialProduct: string;
  selectedProductLine: string;

  isLoading: boolean = false;
  isSelectable: boolean = false;
  isOtherAmount: boolean = false;
  fixedFeeList: CommonDataDTO[];
  public buttonEnabled: boolean = false;

  amount: string = '';
  formattedAmount: string = '';
  amountCustom: string = '';
  formattedAmountCustom: string = '';
  userInfo: any;

  //Loading
  private isExpirationDaysLoading: boolean = false;
  private isLineCommercialLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private requestMgService: RequestDataMgService,
    private credentials: CredentialsService,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService,
    private authenticationService: AuthenticationService,
    private requestsGetDataApi: RequestsGetDataApi
  ) {
    this.userInfo = this.credentials.credentials;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
    if (changes?.establishment) {
      this.reset();
      this.changesDetected();
    }
    //si es el modo visualizacion y es el admin
    // if (
    //   this.mode === REQUEST_MODE_VIEW &&
    //   this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_USUARIO_IMPRESION)
    // ) {
    //   this.changesDetected(changes.establishment.currentValue.id);
    // }
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.requestDataMgForm = this.formBuilder.group({
      expirationDay: ['', Validators.required],
      commercialProduct: ['', Validators.required],
      lineProduct: ['', Validators.required],
      product: ['', Validators.required],
      requestedAmount: ['', Validators.required],
      term: ['', Validators.required],
      tariffs: ['', Validators.required],
      formPayment: ['', Validators.required],
      discountPercentage: [''],
      discountWelcome: [''],
      netPurchaseAmount: [''],
    });

    this.requestDataMgForm.statusChanges.subscribe(() => {
      if (this.requestDataMgForm.valid && this.establishment) {
        this.buttonEnabled = true;
      } else {
        this.buttonEnabled = false;
      }
    });

    this.isExpirationDaysLoading = true;
    this.combosStore
      .loadExpirationDays(10)
      .then(
        (expirationDaysList) => {
          this.expirationDaysList = expirationDaysList;

          //first day by default(ESPSCFWMTS-5245)
          if (this.request?.expirationDay)
            this.requestDataMgForm.controls.expirationDay.setValue(this.request.expirationDay);
          else this.requestDataMgForm.controls.expirationDay.setValue(this.expirationDaysList[0].id);

          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.isLoading = false;
        }
      )
      .finally(() => {
        this.isExpirationDaysLoading = false;
        this.changeLoadingState();
      });

    if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.requestDataMgForm, REQUEST_DATA_MG);
    }

    this.requestDataMgForm.statusChanges.subscribe(() => {
      this.changeContinueStatus.emit({ form: <FormGroup>this.requestDataMgForm, id: REQUEST_DATA_MG });
    });
    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.requestDataMgForm.disable();
        this.calculateFinance();
      }
      this.changesDetected();
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
      this.calculateFinance();
      this.changesDetected();
    }

    this.isLoading = false;
  }

  onLineProductSelected(carga: boolean) {
    this.selectedProductLine = this.requestDataMgForm.controls.lineProduct.value;
    if (this.selectedProductLine !== null && this.selectedProductLine !== undefined) {
      this.combosStore.loadProduct(this.selectedProductLine).then(
        (data) => {
          this.productList = data;
          if (this.productList.length === 1) {
            this.requestDataMgForm.controls.product.setValue(this.productList[0].id);
          }
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          console.error('Error get request');
        }
      );
      if (carga) {
        this.tariffsList = [];
        this.changesDetected();
      }
    }
  }

  private getVideoSelfingDigital(digitalID: DigitalIdDTO) {
    if (this.mode !== REQUEST_MODE_VIEW) {
      this.requestsGetDataApi.getlVideoSelfingDigitalID(digitalID).subscribe(
        (data: DigitalIdResponseDTO) => {
          if (data?.digitalId) {
            if (this.mode == REQUEST_MODE_NEW) {
              this.requestStore.setVideoSelfingID(data.digitalId);
            }
            this.requestStore.setImporteMaxVideoSelfing(data.impMaxOpe11);
          } else {
            this.requestStore.setVideoSelfingID('N');
            this.requestStore.setImporteMaxVideoSelfing(data.impMaxOpe11);
          }
        },
        (error) => {
          this.requestStore.setVideoSelfingID(null);
        }
      );
    }
  }

  changesDetected(): void {
    let lineProductParameter: string;
    if (this.establishment) {
      if (
        this.mode === REQUEST_MODE_VIEW &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
      ) {
        lineProductParameter = this.request.establishment;
      } else {
        lineProductParameter = this.userInfo.typeUser === 'V' ? this.userInfo.parentId : this.userInfo.userId;
      }
    }
    console.log(lineProductParameter);
    this.isLineCommercialLoading = true;
    this.changeLoadingState();
    forkJoin([
      //this.combosStore.loadLineProduct(lineProductParameter),
      this.combosStore.loadLineProduct(this.establishment),
      this.combosStore.loadCommercialProduct(this.establishment, ''),
    ]).subscribe(
      (respuestaFork: any) => {
        this.lineProductList = respuestaFork[0];
        this.commercialProductList = this.combosStore.ComercialProductResponseToCommonData(respuestaFork[1]);

        //si es view mode y es admin, se setea el valor de la request
        if (
          this.mode === REQUEST_MODE_VIEW &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
        ) {
          this.requestDataMgForm.controls.lineProduct.setValue(this.request.productLine);
          this.onLineProductSelected(false);
        } else if (this.lineProductList.length === 1) {
          //si solo hay un valor se setea
          this.requestDataMgForm.controls.lineProduct.setValue(this.lineProductList[0].id);
          this.onLineProductSelected(false);
        }

        if (
          this.mode === REQUEST_MODE_VIEW &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
        ) {
          this.requestDataMgForm.controls.commercialProduct.setValue(this.request.commercialProduct);
          this.selectedCommercialProduct = this.request.commercialProduct;
        } else if (this.commercialProductList.length === 1) {
          this.requestDataMgForm.controls.commercialProduct.setValue(this.commercialProductList[0].id);
        }
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        console.error('Error get anuncios');
      },
      () => {
        this.loadFormPayment();
        this.loadTariffs();
        this.isLineCommercialLoading = false;
        this.changeLoadingState();
      }
    );
  }

  loadFormPayment() {
    if (this.establishment && this.selectedCommercialProduct) {
      //cargar métodos de pago
      this.combosStore.loadFormPayment(FINANCIAL_PRODUCT_MG, this.selectedCommercialProduct).then((data) => {
        this.formPaymentList = data;
        if (
          this.mode === REQUEST_MODE_VIEW &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
        ) {
          this.requestDataMgForm.controls.formPayment.setValue(this.request.formPayment);
        } else if (this.formPaymentList.length === 1) {
          this.requestDataMgForm.controls.formPayment.setValue(this.formPaymentList[0].id);
        }
      });

      if (this.requestDataMgForm.controls.commercialProduct.value) {
        console.log(this.requestDataMgForm.controls.commercialProduct.value);
        this.getVideoSelfingDigital({
          establishment: this.requestStore.listaFormulariosMg[POINT_OF_SALE].controls.establishment.value?.slice(0, -1),
          financialProduct: this.requestDataMgForm.controls.commercialProduct.value?.slice(0, 2),
        });
      }
    }
  }

  loadTariffs() {
    if (
      this.establishment &&
      this.selectedCommercialProduct &&
      this.selectedProductLine &&
      this.tariffsList.length === 0
    ) {
      this.combosStore
        .loadComboTariffs(this.establishment, this.selectedCommercialProduct, this.selectedProductLine)
        .then(
          (data) => {
            this.tariffsList = data;
            if (
              this.mode === REQUEST_MODE_VIEW &&
              this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SEARCH_OPERATION)
            ) {
              this.requestDataMgForm.controls.tariffs.setValue(this.request.tariffSelected);
            } else if (this.tariffsList.length === 1) {
              this.requestDataMgForm.controls.tariffs.setValue(this.tariffsList[0].codigo);
            } else {
              this.buttonEnabled = false;
            }
            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
            console.error('Error get anuncios');
          }
        )
        .finally(() => {
          if (this.mode === REQUEST_MODE_VIEW) {
            this.setValuesToForm();
          }
        });
    }
  }

  onCommercialProductSelected(event: MatSelect) {
    this.selectedCommercialProduct = this.requestDataMgForm.controls.commercialProduct.value;
    this.tariffsList = [];
    this.financeEmitter.emit(null);
    this.changesDetected();
  }

  calculateFinance() {
    this.isLoading = true;
    let financingCallDTO: FinancingCallDTO;
    if (this.requestDataMgForm.valid) {
      financingCallDTO = {
        user: this.credentials.credentials.username, //usuario infovia del usuario en sesion
        establishment: this.establishment, //id primer combo
        financialProduct: 30, //30, es tarjeta, solo valores: [10,20,30]
        financial: '', //financiado??
        comercialProduct: this.requestDataMgForm.controls.commercialProduct.value,
        deadline: this.requestDataMgForm.controls.term.value, //plazo
        sector: this.requestDataMgForm.controls.lineProduct.value, //0043, linea de producto id
        paymentMethod: this.requestDataMgForm.controls.formPayment.value, //TODO: test
        amount: (this.requestDataMgForm.value.requestedAmount as string).endsWith('€')
          ? this.requestDataMgForm.value.requestedAmount.substring(
              0,
              this.requestDataMgForm.value.requestedAmount.length - 2
            )
          : this.requestDataMgForm.value.requestedAmount, //cantidad total, '1000'
        codeTariff: this.requestDataMgForm.controls.tariffs.value.codigo, //GOU
        deposit: '', //entrada, pero no hay campo entrada ¿?
        dayDeadline: this.requestDataMgForm.controls.expirationDay.value, //dia primer pago
        captacionCanal: 'AE', //canal captacion, 'AE'
        vendor: this.vendor,
      };
    }
    console.log(financingCallDTO);
    if (financingCallDTO !== null && financingCallDTO !== undefined) {
      this.isLoading = true;
      this.requestMgService.financingSimulation(financingCallDTO).subscribe(
        (data) => {
          this.financeEmitter.emit(data);
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
          console.error('Error get financiaciones');
        }
      );
    }
  }

  numberOnly(event: any): boolean {
    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, this.amount);
  }

  numberOnlyCustom(event: any): boolean {
    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, this.amountCustom);
  }

  getFormattedAmount() {
    this.formattedAmount = this.customValidators.transformAmount(this.amount);
    this.amount = this.formattedAmount;
  }

  getFormattedAmountCustom() {
    this.formattedAmountCustom = this.customValidators.transformAmount(this.amountCustom);
    this.amountCustom = this.formattedAmountCustom;
  }

  setValuesToForm() {
    this.requestDataMgForm.controls.expirationDay.setValue(this.request.expirationDay);

    this.requestDataMgForm.controls.commercialProduct.setValue(this.request.commercialProduct);
    this.selectedCommercialProduct = this.request.commercialProduct;

    this.requestDataMgForm.controls.lineProduct.setValue(this.request.productLine);
    this.selectedProductLine = this.request.productLine;
    console.log('set productline: ', this.selectedProductLine);

    this.requestDataMgForm.controls.product.setValue(this.request.product);
    this.requestDataMgForm.controls.requestedAmount.setValue(
      this.customValidators.transformAmount(this.request.amount)
    );
    this.amount = this.customValidators.transformAmount(this.request.amount);

    this.requestDataMgForm.controls.term.setValue(this.request.numPlaz);
    this.requestDataMgForm.controls.tariffs.setValue(this.request.tariffSelected);
    this.requestDataMgForm.controls.formPayment.setValue(this.request.formPayment);
    //only view mode
    this.requestDataMgForm.controls.discountPercentage.setValue(this.request.discountPercentage);
    this.requestDataMgForm.controls.discountWelcome.setValue(this.request.discountWelcome);
    this.requestDataMgForm.controls.netPurchaseAmount.setValue(this.request.netPurchaseAmount + '€');
    this.establishment = this.request.establishment;
    this.vendor = this.request.vendor;
  }

  changeLoadingState() {
    if (!this.isExpirationDaysLoading && !this.isLoading && !this.isLineCommercialLoading) {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA_MG, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA_MG, value: false });
    }
  }

  private reset = () => {
    this.commercialProductList = [];
    this.lineProductList = [];
    this.productList = [];
    this.formPaymentList = [];
    this.tariffsList = [];
    this.requestDataMgForm?.reset();
  };
}
